import { getConfigs } from 'core/config/index.js'
import { useUserAuthStore } from 'src/stores/user/auth'
import platform from 'src/common/platform'
import getAuthLink from 'src/apollo/queries/getAuthLink.gql'

const coreConfig = getConfigs()

export function initCDA(apolloClient) {
  const userAuthStore = useUserAuthStore()
  const hasCDA = process.env.VUE_APP_CDA_URL && process.env.WEBVIEW !== '1'
  const token = userAuthStore.getToken

  if (!hasCDA || !token) {
    return
  }

  sessionStorage.setItem('redirect2cda', 'true')

  if (platform.is.ios) {
    return initCDAForIOS(apolloClient)
  } else {
    initCDAForOtherPlatforms(apolloClient)
  }
}

async function initCDAForIOS(apolloClient) {
  try {
    const authLink = await fetchAuthLink(apolloClient)
    if (!authLink) {
      return
    }

    if (!slugsIsChanged(authLink)) {
      return
    }

    const linkTail = getTailForCdaLink(authLink)
    setForIOS(linkTail)
  } catch (e) {
    console.error(e)
  }
}

function initCDAForOtherPlatforms(apolloClient) {
  fetchAuthLink(apolloClient)
    .then((authLink) => {
      if (!authLink) {
        return
      }

      if (!slugsIsChanged(authLink)) {
        return
      }

      const linkTail = getTailForCdaLink(authLink)
      setCookiesByIframe(linkTail)
      setCookiesByImage(linkTail)
    })
    .catch((e) => {
      console.error(e)
    })
}

function fetchAuthLink(apolloClient) {
  return apolloClient
    .query({
      query: getAuthLink,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => data.authLink)
    .catch((e) => {
      console.error('Error fetching authLink:', e)
      return null
    })
}

function slugsIsChanged(authLink) {
  const oldCdaKey = localStorage.getItem(coreConfig.CDA_KEY)
  const key = authLink.uuid + authLink.uuidSecond

  if (oldCdaKey !== key) {
    localStorage.setItem(coreConfig.CDA_KEY, key)
    return true
  }
  return false
}

function getTailForCdaLink(data) {
  const hashStr = encodeURIComponent(data.hashStr)
  return `?slug=${data.uuid}&slug2=${data.uuidSecond}&hashstr=${hashStr}`
}

function setForIOS(linkTail) {
  window.location.replace(getRedirectLink(linkTail))
}

function getSimpleLink(tailForCda) {
  return `${process.env.VUE_APP_CDA_URL}slug/${tailForCda}`
}

function getRedirectLink(tailForCda) {
  const href = location.href.endsWith('/') ? location.href.slice(0, -1) : location.href
  return `${process.env.VUE_APP_CDA_URL}slug-r/${tailForCda}&url=${encodeURIComponent(href)}`
}

function setCookiesByIframe(linkTail) {
  const link = getSimpleLink(linkTail)

  const iframe = document.createElement('iframe')
  iframe.src = link
  iframe.name = 'cookiesHackFrame'
  iframe.style = 'display: none'

  const formElement = document.createElement('form')
  formElement.action = link
  formElement.id = 'cookiesHackForm'
  formElement.method = 'post'
  formElement.target = 'cookiesHackFrame'
  formElement.style = 'display: none'

  const body = document.querySelector('body')
  iframe.onload = function () {
    formElement.submit()
    iframe.remove()
    formElement.remove()
  }

  body.appendChild(iframe)
  body.appendChild(formElement)
}

function setCookiesByImage(linkTail) {
  const image = document.createElement('img')
  image.src = getSimpleLink(linkTail)
  image.style = 'opacity: 0; position: absolute; left: -999px; width: 1px; height: 1px'

  image.onload = function () {
    image.remove()
  }
  image.onerror = function () {
    image.remove()
  }

  const body = document.querySelector('body')
  body.appendChild(image)
}
